const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

function buildUrl(path, params) {
  const url = new URL(`${API_BASE_URL.replace(/\/$/, '')}${path}`);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.append(key, value);
    }
  });
  return url.toString();
}

async function request(path, params) {
  const response = await fetch(buildUrl(path, params), { method: 'GET' });
  if (!response.ok) {
    throw new Error(`Request failed (${response.status}) ${response.statusText}`);
  }
  const payload = await response.json();
  return payload?.data ?? null;
}

function buildQuery({ feDesde, feHasta, cdPresupuesto }) {
  return {
    fe_desde: feDesde,
    fe_hasta: feHasta,
    cd_presupuesto: cdPresupuesto,
  };
}

export function fetchGastosMes({ feDesde, feHasta, cdPresupuesto } = {}) {
  return request('/dashboard/gastos-mes', buildQuery({ feDesde, feHasta, cdPresupuesto }));
}

export function fetchIngresosMes({ feDesde, feHasta, cdPresupuesto } = {}) {
  return request('/dashboard/ingresos-mes', buildQuery({ feDesde, feHasta, cdPresupuesto }));
}

export function fetchSaldoDisponible({ feDesde, feHasta, cdPresupuesto } = {}) {
  return request('/dashboard/saldo-disponible', buildQuery({ feDesde, feHasta, cdPresupuesto }));
}

export function fetchAhorros({ feDesde, feHasta, cdPresupuesto } = {}) {
  return request('/estadisticas/ahorros', buildQuery({ feDesde, feHasta, cdPresupuesto }));
}

export function fetchTransaccionesDetalle({ feDesde, feHasta, cdPresupuesto } = {}) {
  return request('/transacciones/presupuesto', buildQuery({ feDesde, feHasta, cdPresupuesto }));
}
